/**
 * @generated SignedSource<<7eae68739e26073d14241fa3e7f7620d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AskCopilotMessageRating = "NEGATIVE" | "POSITIVE";
export type AskFellowPanelInnerRateMessageMutation$variables = {
  messageId: string;
  rating: AskCopilotMessageRating;
};
export type AskFellowPanelInnerRateMessageMutation$data = {
  readonly askCopilotRateAiResponse: {
    readonly message: {
      readonly userRating: AskCopilotMessageRating | null;
    };
  } | null;
};
export type AskFellowPanelInnerRateMessageMutation$rawResponse = {
  readonly askCopilotRateAiResponse: {
    readonly message: {
      readonly id: string;
      readonly userRating: AskCopilotMessageRating | null;
    };
  } | null;
};
export type AskFellowPanelInnerRateMessageMutation = {
  rawResponse: AskFellowPanelInnerRateMessageMutation$rawResponse;
  response: AskFellowPanelInnerRateMessageMutation$data;
  variables: AskFellowPanelInnerRateMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "messageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rating"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "messageId",
    "variableName": "messageId"
  },
  {
    "kind": "Variable",
    "name": "rating",
    "variableName": "rating"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userRating",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowPanelInnerRateMessageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AskCopilotRateAiResponse",
        "kind": "LinkedField",
        "name": "askCopilotRateAiResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotMessage",
            "kind": "LinkedField",
            "name": "message",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AskFellowPanelInnerRateMessageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AskCopilotRateAiResponse",
        "kind": "LinkedField",
        "name": "askCopilotRateAiResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotMessage",
            "kind": "LinkedField",
            "name": "message",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c48854ea066e58c99294c117f8f189bd",
    "id": null,
    "metadata": {},
    "name": "AskFellowPanelInnerRateMessageMutation",
    "operationKind": "mutation",
    "text": "mutation AskFellowPanelInnerRateMessageMutation(\n  $messageId: ID!\n  $rating: AskCopilotMessageRating!\n) {\n  askCopilotRateAiResponse(messageId: $messageId, rating: $rating) {\n    message {\n      userRating\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f20b316ad17d89675813d8d4b83aa7d";

export default node;
